









import { BaseInput } from '#components/dms/common/baseInput';

export default BaseInput.extend({
	name: 'DmsSave',
	props: {
		isModified: { type: Boolean, required: true },
		isArchive: Boolean,
	},
	computed: {
		icon(): string {
			return this.isArchive ? '' : '';
		},
	},
});
